import React from "react";
import { CheckCircle, Building2, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";

const features = [
    "Three-tier above-ground parking system",
    "Cost-effective and space-efficient solution",
    "Independent access to each vehicle without shifting others",
    "Minimal civil work required — no pit needed",
    "Fast installation and low maintenance",
];

const applications = [
    "Residential Apartments",
    "Commercial Complexes",
    "Offices with Medium Parking Demand",
    "Hospitals & Clinics",
    "Retail Showrooms and Dealerships",
];

const ThreeLevelParkingDetail = () => {
    const navigate = useNavigate()
    return (
        <section className="about-wrapper">
            {/* Hero */}
            <div className="about-hero">
                <div className="hero-content">
                    <h1>3 Level Parking System</h1>
                    <p>
                        A surface-mounted parking system with three stacked levels that increases parking capacity while minimizing land usage. Ideal for medium-density sites requiring independent car access.
                    </p>
                </div>
            </div>

            {/* Description */}
            <div className="about-section">
                <h2>What is 3 Level Parking?</h2>
                <p>
                    3 Level Parking is a semi-automatic parking system built above the ground to accommodate three vehicles vertically — one on each platform level. The system enables vertical lifting and horizontal sliding to allow access to any vehicle without disturbing others.
                </p>
                <p>
                    It is best suited for sites where excavation is not feasible. The design is modular and can be customized based on vehicle dimensions, entry type, and usage frequency.
                </p>
            </div>

            {/* Features */}
            <div className="about-section">
                <h2>Key Features & Benefits</h2>
                <ul className="lt-puzzle-list">
                    {features.map((item, index) => (
                        <li key={index}><CheckCircle size={18} /> {item}</li>
                    ))}
                </ul>
            </div>

            {/* How it Works */}
            <div className="about-section">
                <h2>How It Works</h2>
                <p>
                    The 3-level parking structure uses motorized lifts to move platforms up or down, depending on where the vehicle is parked. Each car is accessible directly from the ground level after the necessary shift sequence is completed.
                </p>
                <p>
                    Equipped with safety sensors and mechanical locks, the system is controlled by a central PLC panel and is operated via buttons or touchscreen panels for ease of use and safety.
                </p>
            </div>

            {/* Applications */}
            <div className="about-section">
                <h2>Best Suited For</h2>
                <ul className="lt-puzzle-list">
                    {applications.map((item, index) => (
                        <li key={index}><Building2 size={18} /> {item}</li>
                    ))}
                </ul>
            </div>

            {/* Call to Action */}
            <div className="lt-puzzle-cta">
                <div className="lt-puzzle-cta-content">
                    <h3>Need a 3 Level Parking solution?</h3>
                    <p>Contact LIFTECH ENGINEERING PVT. LTD. today to optimize your site's parking with smart vertical stacking.</p>
                    <button className="lt-puzzle-contact-btn" onClick={() => navigate("/get-started")}>
                        <PhoneCall size={18} /> Request Consultation
                    </button>
                </div>
            </div>
        </section>
    );
};

export default ThreeLevelParkingDetail;
